import { Link } from "react-router-dom";
import Seo, { breadcrumbLd } from "@/components/seo/Seo";
import { PSEO_GROUPS } from "@/content/pseo";

const SITE_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");

const CORE = [
  { title: "Buying and purity", pages: [
    ["Benefits of cold pressed coconut oil", "/cold-pressed-coconut-oil-benefits"],
    ["Cold pressed vs refined coconut oil", "/cold-pressed-vs-refined-coconut-oil"],
    ["How to check coconut oil purity at home", "/how-to-check-coconut-oil-purity"],
    ["Our lab reports", "/lab-reports"],
    ["Every lab test explained", "/coconut-oil-lab-report-explained"],
  ] },
  { title: "Cooking science", pages: [
    ["Cooking with coconut oil", "/cooking-with-coconut-oil"],
    ["Coconut oil cooking temperatures", "/coconut-oil-cooking-temperature"],
    ["9 studies on cooking with coconut oil", "/coconut-oil-cooking-studies"],
    ["Coconut oil vs other cooking oils", "/coconut-oil-vs-other-cooking-oils"],
    ["Coconut oil in Ayurveda", "/ayurvedic-benefits-of-coconut-oil"],
  ] },
  { title: "Hair, skin and baby care", pages: [
    ["Coconut oil for hair", "/coconut-oil-for-hair"],
    ["Coconut oil for skin", "/coconut-oil-for-skin"],
    ["Coconut oil for baby massage", "/coconut-oil-for-baby-massage"],
    ["Oil pulling with coconut oil", "/oil-pulling-with-coconut-oil"],
  ] },
];

export default function GuidesIndex() {
  const groups = [
    ...CORE,
    ...PSEO_GROUPS.map((g) => ({ title: g.title, pages: g.pages.map((p) => [p.title, `/${p.slug}`]) })),
  ];
  const all = groups.flatMap((g) => g.pages);
  const jsonLd = [
    breadcrumbLd([{ name: "Home", path: "/" }, { name: "Guides", path: "/guides" }]),
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Karijeeva coconut oil guides",
      itemListElement: all.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, url: `${SITE_URL}${path}` })),
    },
  ];
  return (
    <>
      <Seo
        title="Coconut Oil Guides: Cooking, Purity, Hair and Skin"
        description="Every Karijeeva guide in one place: coconut oil for dosa, tadka and frying, how it compares with other oils, purity checks, hair and skin routines."
        url={`${SITE_URL}/guides`}
        jsonLd={jsonLd}
      />
      <section className="bg-brand-parchment" data-testid="page-guides">
        <div className="max-w-6xl mx-auto px-6 pt-16 sm:pt-24 pb-24">
          <h1 className="font-display text-[clamp(2.6rem,7vw,5rem)] leading-[1] tracking-display text-brand-ink">Coconut oil, explained.</h1>
          <p className="mt-5 max-w-2xl font-body text-[18px] sm:text-[20px] text-ink-muted leading-snug">
            Straight answers for Indian kitchens: which dishes coconut oil suits, how it compares with other oils, how to check it is pure, and how to use it on hair and skin.
          </p>
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {groups.map((g) => (
              <div key={g.title} className="rounded-3xl bg-white p-7">
                <h2 className="font-display text-[22px] tracking-[-0.02em] text-brand-ink">{g.title}</h2>
                <ul className="mt-4 space-y-2">
                  {g.pages.map(([t, to]) => (
                    <li key={to}><Link to={to} className="font-body text-[15px] text-ink-muted hover:text-brand-ink hover:underline">{t}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
